import { Stack, Box, SvgIcon, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInbox } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

// Shared empty state for the asset filter panel (bookmarks / popular /
// most-viewed / recently-changed). "all" never reaches this — the menu shows
// the asset tree for that case — so one filter-agnostic message is correct.
// Muted neutrals only: the empty state is not an action, so it stays off the
// brand accent per the one-accent rule.
export const FilterEmpty = () => {
  const { t } = useTranslation();

  return (
    <Stack
      data-testid="filter-empty"
      spacing={1}
      sx={{
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 2,
        py: 5,
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "action.hover",
          color: "text.secondary",
        }}
      >
        <SvgIcon sx={{ fontSize: 18 }}>
          <FontAwesomeIcon icon={faInbox} />
        </SvgIcon>
      </Box>
      <Typography variant="body2" sx={{ color: "text.secondary" }}>
        {t("assets.filterEmpty")}
      </Typography>
    </Stack>
  );
};
